import React from 'react'

const OverdueIcon = () => {
  return (
    <svg
      aria-hidden="true"
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="16" height="16" rx="8" fill="#E01E4E" />
      <path
        d="M8.5 4V9"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.5 13C9.05228 13 9.5 12.5523 9.5 12C9.5 11.4477 9.05228 11 8.5 11C7.94772 11 7.5 11.4477 7.5 12C7.5 12.5523 7.94772 13 8.5 13Z"
        fill="white"
      />
    </svg>
  )
}

export default OverdueIcon
